(function ($, angular) {
    'use strict';
    angular
        .module('sites.menu', [])
        .controller('SitesMenu', ['$scope', '$filter', function ($scope, $filter) {
            $scope.model = {};
            $scope.maxSites = 5;
            $scope.model.siteQuery = '';
            $scope.filter = function () {
                return $filter('filter')($scope.model.sites || [], $scope.model.siteQuery);
            };

            $scope.showMore = function () {
                return $scope.filter().length > $scope.maxSites;
            };
        }]);
    $(function () {
        angular.bootstrap($('#sitesMenu').get(), ['sites.menu']);

        //Manually do the dropdown trigger because we don't want to dismiss it when clicking on items in the menu
        $('li#sitesMenu.dropdown>a').on('click', function (event) {
            $(this).parent().toggleClass('open');
            return false;
        });

        $('body').on('click', function (e) {
            var dropdown = $('li#sitesMenu.dropdown');
            if (!dropdown.is(e.target)
                && dropdown.has(e.target).length === 0
                && $('.open').has(e.target).length === 0
            ) {
                dropdown.removeClass('open');
            }
        });

    });
})(window.jQuery, window.angular);
